
import { HelpCircle } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { useTheme } from "@/lib/theme/ThemeContext"

interface SleepDialogHeaderProps {
  childName?: string
}

export function SleepDialogHeader({ childName }: SleepDialogHeaderProps) {
  const isLightTheme = false;

  return (
    <DialogHeader className="relative border-b pb-4 border-[#333333]/80">
      <DialogTitle className={`text-center text-xl font-bold ${isLightTheme ? "" : "text-gradient"}`}>
        {childName ? `Record ${childName}'s Sleep` : 'Record Sleep'}
      </DialogTitle>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className={`absolute right-2 top-2 h-8 w-8 rounded-full p-0 ${
              isLightTheme 
                ? "text-slate-400 hover:text-slate-600 hover:bg-slate-100" 
                : "text-[#9F9EA1] hover:text-[#D6BCFA] hover:bg-[#9b87f5]/10"
            } transition-colors`}
          >
            <HelpCircle className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent 
          className={`max-w-[300px] p-4 ${isLightTheme 
            ? "bg-white border-slate-200 text-slate-700" 
            : "bg-[#222222] border border-[#333333] text-[#C8C8C9]"
          }`} 
          side="right"
          align="start"
          sideOffset={10}
        >
          <p className="mb-2">
            Quality nighttime sleep is essential for your baby's:
          </p>
          <ul className="mb-4 space-y-1 list-disc list-inside">
            <li>Growth and development</li>
            <li>Learning and memory consolidation</li>
            <li>Mood regulation</li>
            <li>Immune system function</li>
          </ul>
          <p>
            Tracking sleep patterns helps establish healthy routines.
          </p>
        </PopoverContent>
      </Popover>
    </DialogHeader>
  )
}
